<!--
    描述：资源库页面
    时间：2020-06-16
    Created by yefan
-->
<template>
	<div class="resources-main w-tabs-layout">
		<el-tabs v-model="activeName"
				 @tab-click="handleClick">
			<el-tab-pane label="材料"
						 name="materials">
				<materialsInfo v-if="activeName === 'materials'"></materialsInfo>
			</el-tab-pane>
			<el-tab-pane label="劳务"
						 name="professionals">
				<professionalsInfo v-if="activeName === 'professionals'"></professionalsInfo>
			</el-tab-pane>
			<el-tab-pane label="设备租赁"
						 name="equipments">
				<span>设备租赁</span>
			</el-tab-pane>
			<el-tab-pane label="分包"
						 name="subcontractors">
				<span>分包</span>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import materialsInfo from './materials_info'
import professionalsInfo from './professionals_info'

export default {
	name: 'resources-management',
	components: { materialsInfo, professionalsInfo },
	data() {
		return {
			activeName: 'materials'
		}
	},
	created() {},
	methods: {
		// 切换tab 的事件
		handleClick(tab) {
			let type = null
			switch (this.activeName) {
				case 'materials':
					type = 1
					break
				case 'professionals':
					type = 2
					break
				case 'equipments':
					type = 3
					break
				case 'subcontractors':
					type = 4
					break
				default:
					return
			}

			this.$router.push({
				query: {
					type: type
				}
			})
		},

		// 初始 tabName
		setActiveName() {
			switch (parseInt(this.curType)) {
				case 1:
					this.activeName = 'materials'
					break
				case 2:
					this.activeName = 'professionals'
					break
				case 3:
					this.activeName = 'equipments'
					break
				case 4:
					this.activeName = 'subcontractors'
					break
				default:
					this.activeName = 'materials'
					return
			}
		}
	},
	computed: {
		// 当前类型 1： 材料  2： 劳务  3： 设备租赁 4：分包
		curType() {
			return this.$route.query.type
		}
	}
}
</script>

<style lang="less" scoped>
.resources-main {
	height: 100%;
	background-color: #fff;
	padding: 0 10px;
}
/deep/ .el-tabs__content {
	height: calc(100% - 40px);
}
</style>
